import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  addFamilySharing,
  AddFamilySharing,
  ApiError,
  userEntersEmail
} from '../actions/Actions';
import { IProductInfo, IState, IUserInfo } from '../CustomTypes';
import InputField from '../input-components/InputField';
import { validateEmail } from '../validators';
import { svgShared, svgPlus, svgMinus } from '../icons';
import Button from './Button';
import './FamilySharing.scss';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IActionProps {
  userEntersEmail: userEntersEmail;
  addFamilySharing: AddFamilySharing;
}

export interface IStateProps {
  userInfo: IUserInfo;
  productInfo: IProductInfo;
}

export interface IProps extends IStateProps, IActionProps {}

export class FamilySharing extends React.Component<
  IProps,
  {
    alreadyShared: boolean;
    clicked: boolean;
    email: string;
    shared: boolean;
    validationError: boolean;
  }
> {
  constructor(props: IProps) {
    super(props);
    this.showContentIfClicked = this.showContentIfClicked.bind(this);
    this.headingClicked = this.headingClicked.bind(this);
    this.shareProduct = this.shareProduct.bind(this);
    this.trackSharedToFamily = this.trackSharedToFamily.bind(this);
    this.state = {
      alreadyShared: false,
      clicked: false,
      email: '',
      shared: false,
      validationError: false
    };
  }

  public render() {
    const { clicked } = this.state;
    return (
      <div className="familySharing">
        <div className="clickable-heading" onClick={this.headingClicked}>
          <span>{svgShared()}</span>
          <span className="text">Del gjerne ditt abonnement gratis</span>
          <span>{clicked ? svgMinus() : svgPlus()}</span>
        </div>
        {this.showContentIfClicked()}
      </div>
    );
  }

  private showContentIfClicked() {
    const {
      alreadyShared,
      clicked,
      email,
      shared,
      validationError
    } = this.state;
    if (!clicked) {
      return;
    }

    if (alreadyShared) {
      return (
        <div className="content">
          <div className="heading">
            <div className="alreadyShared">
              Du har allerede delt ditt digitalabonnement. Du kan endre hvem du
              ønsker å dele det med på Min Side.
            </div>
          </div>
        </div>
      );
    }

    if (shared) {
      return (
        <div className="content">
          <div className="heading">
            <span>
              Du har nå sendt en invitasjon om familiedeling til{' '}
              <span className="bold">{email}</span>
            </span>
          </div>
        </div>
      );
    }

    const { myPageUrl } = this.props.productInfo;
    return (
      <div className="content">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1">
            <div className="heading">
              Legg inn e-posten til den du ønsker å dele ditt abonnement med
            </div>
            <InputField
              value={this.state.email}
              initialFocus={true}
              onChange={e => this.setState({ email: e.currentTarget.value })}
              formSubmitted={false}
              label="E-post"
              placeholder="ola.nordmann@gmail.com"
              type={'email'}
              maxLength={320}
              validationErrorMessage="Vennligst oppgi en gyldig e-post adresse"
              validator={validateEmail}
            />
            {validationError && (
              <div className="errorText">
                Det har dessverre skjedd en feil. Prøv gjerne igjen senere på{' '}
                <a href={myPageUrl}>Min side.</a>
              </div>
            )}
            <Button
              onClick={this.shareProduct}
              disabled={!validateEmail(email)}
            >
              Del ditt abonnement
            </Button>
          </div>
        </div>
      </div>
    );
  }

  private headingClicked() {
    this.setState({ clicked: !this.state.clicked });
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      'click show family sharing'
    );
  }

  private shareProduct() {
    this.setState({ validationError: false });
    const { sig, spidId } = this.props.userInfo;
    (this.props.addFamilySharing(spidId, this.state.email, sig) as any)
      .then(() => {
        this.setState({ shared: true });
        this.trackSharedToFamily('OK');
      })
      .catch((res: ApiError) => {
        if (res.status === 409) {
          this.setState({ alreadyShared: true });
          this.trackSharedToFamily('Already shared');
        } else {
          this.setState({ validationError: true });
          this.trackSharedToFamily('Error');
        }
      });
  }

  private trackSharedToFamily(result: string) {
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      'shared to family',
      { result }
    );
  }
}

export default connect<IStateProps, IActionProps, {}>(
  (state: IState) =>
    ({
      productInfo: state.productInfo,
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        addFamilySharing,
        userEntersEmail
      },
      dispatch
    ) as IActionProps
)(FamilySharing);



// WEBPACK FOOTER //
// ./src/input-components/FamilySharing.tsx